import React from 'react';
import {Card, CardContent, Typography} from '@mui/material';
import {useTheme} from '@mui/system';
import FileDataSActivity from 'src/sections/file-manager/Newdata';

const TIME_LABELS = {
  month: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]
};

const TopProjectsBarChart: React.FC = () => {
  const theme = useTheme();
  return (
    <Card>
      <CardContent>
        <Typography
          variant="h6"
          gutterBottom
          style={{
            display: 'flex',
            marginBottom: '0px',
            fontSize: '1.2rem',
            alignItems: 'center',
            flexWrap: 'wrap'
          }}>
          IT Portfolio Cost Overview
          {/* <InfoIcon color="action" style={{ paddingLeft: '5px', color: '#4040ab' }} /> */}
        </Typography>
        <Typography
          color="grey"
          style={{display: 'flex', fontWeight: '300', fontSize: ' 0.7rem'}}>
          This Year To Date (2024) - March (in USD)
        </Typography>
        <FileDataSActivity
          title="It Resource Tower Stand"
          chart={{
            labels: TIME_LABELS,
            colors: [
              theme.palette.primary.main,
              theme.palette.error.main,
              theme.palette.warning.main,
              theme.palette.text.disabled
            ],
            series: [
              {
                type: 'Month',
                data: [
                  {name: 'Other', data: [400000, 140000, 0]},
                  {name: 'License', data: [900275, 320000, 412719]},
                  {name: 'Annual Maintenance', data: [748000, 200000, 50000]},
                  {name: 'Infrastructure', data: [0, 600000, 72000]},
                  {name: 'Staff', data: [385545, 330000, 385545]},
                  {name: 'Hosting/On-prem', data: [92220, 92220, 92220]},
                  {name: 'Server Upgrades', data: [99167, 99167, 440000]},
                  {name: 'Help Desk Support', data: [57799, 57799, 57799]}
                ]
              }
            ]
          }}
        />
      </CardContent>
    </Card>
  );
};

export default TopProjectsBarChart;
